import { SafetiesListType } from "../../../../../models/list"

export const convertData = (data: SafetiesListType[]): SafetiesListType[] =>
  data.map((item, index) => ({
    ...item,
    id: index,
  }))
